services.service('AssetService', [
    '$q', 'config', 'constants', 'ErrorService', 'API', 'AssetCollection', 'AssetModel', 'UserService',
    'FavoritesService', 'Validator', 'Utils', 'CurrencyConvertService', 'CustomerEventsService',
    function ($q, config, Const, ErrorService, API, AssetCollection, AssetModel, UserService, FavoritesService,
              Validator, Utils, CurrencyConvertService, CustomerEventsService) {
        var self = this;

        self.collection = null;
        self.clientCollection = null;
        self.clientQuickAccessCollection = null;

        self.assetCategories = null;

        //Start the service
        this.init = function () {

            var user = UserService.get();

            self.collection = new AssetCollection();
            self.clientCollection = new AssetCollection();
            self.clientQuickAccessCollection = new AssetCollection();

            API.unsubscribe('subscribe');

            log('assetService init');

            if (user.loggedIn && user.activeTradingAccount) {
                return $q.all([
                    getAssets(user)
                        .then(initAssets)
                        .then(getClientAssets)
                        .then(initConvAssets)
                        .then(self.subscribe)
                    ,
                    getSymbolCategories()
                ])

            }

            return getAllAssets(user)
                .then(initAssets)
                .then(getVisibleAssets)
                .then(initConvAssets)
                .then(self.subscribe);
        };

        function checkResponse(data) {
            if (data[0].status !== 1 || data[1].status !== 1) {
                throw new ErrorService({
                    source: 'AssetService',
                    type: Const.error.type.SYSTEM,
                    severity: 'critical',
                    code: 'getSymbolsFailed',
                    data: {
                        /*login: UserService.get().activeAccountId,
                        source: UserService.get().activeAccountSource,*/
                        failedRequest: data[0].status !== 1
                            ? "mt4GetAllSymbols"
                            : (data[1].status !== 1 && "mt4GetClientSymbols")
                    }
                });
            }
            return data;
        }

        function validateAsset(data) {
            var errors = [],
                rules = config.validations.asset;

            var validated = Validator(data, rules);

            if (validated) {
                errors.push({
                    asset: data.OutputName,
                    assetId: data.id,
                    validations: validated
                })
            }

            if (errors.length > 0) {
                return new ErrorService({
                    source: 'AssetService',
                    severity: 'warning',
                    type: Const.error.type.VALIDATION,
                    message: 'asset validation failed',
                    data: errors
                }, true)
            }
        }

        //Get all assets from socket
        function getAssets() {
            //Merge two arrays of assets and update some fields
            function setClientSymbols(data) {

                var symbols = [],
                    allSymbols = data[0].Symbols,
                    clientSymbols = data[1].Symbols;

                allSymbols.forEach(function (symbol) {
                    var client = _.find(clientSymbols, {id: symbol.id});
                    if (client) {
                        symbol.IsTradeable = client.IsTradeable;
                        symbol.Markup = client.Markup;
                        symbol.Percentage = client.Percentage;
                        symbol.MaxLot = client.MaxLot;
                        symbol.MinLot = client.MinLot;
                        symbol.StepLot = client.StepLot;
                        symbol.SwapsLong = client.SwapsLong;
                        symbol.SwapsShort = client.SwapsShort;
                        symbol.SwapsCode = client.SwapsCode !== null && client.SwapsCode >= 0 ? client.SwapsCode : 3;

                        symbol.StopLevels = client.hasOwnProperty('StopLevels') ? client.StopLevels : symbol.StopLevels;
                        symbol.IsShow = client.hasOwnProperty('IsShow') ? Utils.toBoolean(client.IsShow) : true;
                        symbol.isClient = true;
                    } else {
                        symbol.IsShow = false;
                    }
                    symbols.push(symbol);
                });

                return symbols;
            }

            return $q.all([API.mt4GetAllSymbols(), API.mt4GetClientSymbols()])
                .then(checkResponse)
                .then(setClientSymbols)
        }

        function getAllAssets() {

            function check(data) {
                if (data.status !== 1) {
                    throw new ErrorService({
                        source: 'AssetService',
                        type: Const.error.type.SYSTEM,
                        severity: 'critical',
                        code: 'getAllSymbolsFailed'
                    });
                }
                return data.Symbols;
            }

            return API.mt4GetAllSymbols()
                .then(check)
        }

        function getSymbolCategories(){
            function check(data) {
                if (data.status !== 1) {
                    throw new ErrorService({
                        source: 'AssetService',
                        type: Const.error.type.SYSTEM,
                        severity: 'critical',
                        code: 'GetSymbolCategoriesFailed'
                    });
                }
                return data.Categories;
            }

            return API.MT4GetSymbolCategories().then(function(response){
                self.assetCategories = check(response);
            }).catch(function(){
                self.assetCategories = Const.assetsTypes;
            })
        }

        function assetFactory(strategy, item) {
            var isFavorite = FavoritesService.get(item.id) && true;
            switch (strategy) {
                case 'esma':
                    if (item.s.match(/\!/)) {
                        item.IsShow = 1;
                        item.isEsma = true;
                    } else {
                        item.IsShow = 0;
                    }
                    return new AssetModel(item, false, isFavorite);
                default:
                    if (item.s.match(/\!/)) {
                        item.IsShow = 0;
                        item.isEsma = true;
                    }
                    return new AssetModel(item, false, isFavorite);
            }
        }

        function createStrategy() {
            var user = UserService.get();
            return user && user.activeTradingAccount && user.activeTradingAccount.isEsma && 'esma';
        }

        //Create asset models from raw data and put it into collection
        function initAssets(data) {
            var strategy = createStrategy();
            data.forEach(function (item) {
                //if (!validateAsset(item)) {
                    var asset = assetFactory(strategy, item);
                    self.collection.add(asset);
                //}
            });
        }

        function getClientAssets() {
            var clientAssets = self.collection.find({
                isShow: true,
                isClient: true
            });
            self.clientCollection.fill(clientAssets);

            var quickAccessAssets = self.clientCollection.find({
                quickAccess: true
            })
            self.clientQuickAccessCollection.fill(quickAccessAssets);
        }

        /**
         * Return assets for non-login user (without trading accounts)
         */
        function getVisibleAssets() {
            var visibleAssets = self.collection.find({
                isShow: true
            });
            self.clientCollection.fill(visibleAssets);
        }

        //Update asset with new values
        function updateChunk(data) {
            data.reduce(function (rev, item) {
                var asset = self.collection.get({id: item[0]});
                if (asset) {
                    asset.update(item);
                }
            }, data[0]);

            data = null;
        }

        this.sortByFavorites = function (filter) {
            var assetsFav = FavoritesService.getAll(),
                assets = self.clientCollection.find(filter),
                sortedAssets = [];

            assetsFav.forEach(function (assetId) {
                sortedAssets.push(_.find(assets, {id: assetId}));
            });

            return sortedAssets;
        };

        //Subscribe to asset updates
        this.subscribe = function () {
            log('Starting to listen to socket updates');
            API.subscribe('quotes', updateChunk);
            var activeAccount = UserService.get().activeTradingAccount;
            API.quotesSubscribe({real: activeAccount ? Utils.fromBoolean(activeAccount.live) : 0});

            // margin call
            API.unsubscribe('MT4MarginCallAdd');
            API.subscribe('MT4MarginCallAdd', function () {
                var user = UserService.get();
                CustomerEventsService.trackEvent(CustomerEventsService.events.MarginCall, {
                    marginLevel: user.activeTradingAccount.marginLevel
                })
            });
        };


        function initConvAssets () {
            //var searchService = new CurrencyConvertService(self, UserService);
            var searchService = CurrencyConvertService;

            var user = UserService.get();

            self.collection.getAll()
                .forEach(function (asset) {
                    var convAssets = [];
                    var convAssetsMargin = [];
                    try {
                        convAssets = searchService.find(self, asset.baseCurrency, user.currency, asset.ending, asset.profitMode);
                        convAssetsMargin = (asset.profitMode === 0)
                            ? searchService.find(self, asset.currency, user.currency, asset.ending, asset.profitMode)
                            : convAssets;

                        asset.setConvAssets(convAssets);
                        asset.setConvAssetsMargin(convAssetsMargin);
                    } catch (e) {
                        console.warn('NO CONV ASSETS FOR:', asset.s, 'TO USER CURRENCY:', user.currency);
                    }
                });
        }

        this.getAssetByName = function(name) {
            return self.clientCollection.get({outputName: name.toUpperCase()})
        }

        this.clear = function () {
            log('clear asset service');
            API.quotesUnsubscribe();
            API.unsubscribe('quotes', updateChunk);
            self.collection && self.collection.clear();
            // self.collection = null;
        };

        return this;

    }]);
